import { Box } from "@mui/material";

export default function CarouselDots({
  count = 0,
  activeIndex = 0,
  onSelect,
}) {
  if (count <= 1) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        px: 1.5,
        py: 0.5,
        gap: 1.25,
        borderRadius: 999,
      }}
    >
      {Array.from({ length: count }).map((_, i) => {
        const active = i === activeIndex;

        return (
          <Box
            key={i}
            onClick={() => onSelect?.(i)}
            sx={{
              width: active ? 10 : 8,
              height: active ? 10 : 8,
              borderRadius: "50%",
              backgroundColor: active
                ? "primary.main"
                : "grey.200",
              cursor: "pointer",
              transition: "all 200ms ease",
              "&:hover": {
                backgroundColor: active
                  ? "primary.main"
                  : "grey.400",
              },
            }}
          />
        );
      })}
    </Box>
  );
}